// extracted by css-extract-rspack-plugin
export default {"titleInput":"pEn7T","titleContainer":"Mz4Nh","actionsContainer":"HYUpv","commentsIcon":"QAZUO"};